<div *ngIf="orderBOLOCR$ | async as orderBOLOCR">
  <div class="flex flex-row h-full">
    <div class="w-1/4 px-1">
      <div class="pt-1 pb-1 flex border-b border-t border-gray-400 font-semibold">
        <div class="flex-1">Order ID:</div>
        <div class="flex-1">{{ orderBOLOCR.orderId }}</div>
      </div>
      <div
        class="pt-1 pb-1 flex border-b border-gray-400"
        (mouseenter)="highlightLocationType = BOL_NUMBER_LOCATION_TYPE"
        (mouseleave)="highlightLocationType = ''"
      >
        <div class="flex-1 text-gray-700">BOL Number:</div>
        <div class="flex-1 text-gray-700">{{ orderBOLOCR.bolNumber }}</div>
        <div class="flex-1 text-gray-700">{{ bolNumberFound ? 'Found' : 'Not Found' }}</div>
      </div>
      <div
        class="pt-1 pb-1 flex border-b border-gray-400"
        (mouseenter)="highlightLocationType = PURCHASE_ORDER_LOCATION_TYPE"
        (mouseleave)="highlightLocationType = ''"
      >
        <div class="flex-1 text-gray-700">PO Number:</div>
        <div class="flex-1 text-gray-700">{{ orderBOLOCR.purchaseOrderNumber }}</div>
        <div class="flex-1 text-gray-700">{{ poNumberFound ? 'Found' : 'Not Found' }}</div>
      </div>
      <div
        class="pt-1 pb-1 flex border-b border-gray-400"
        (mouseenter)="highlightLocationType = LOAD_WEIGHT_LOCATION_TYPE"
        (mouseleave)="highlightLocationType = ''"
      >
        <div class="flex-1 text-gray-700">Load Weight:</div>
        <div class="flex-1 text-gray-700">
          {{ orderBOLOCR.actualLoadWeight }} {{ orderBOLOCR.actualLoadWeightUnit }}
        </div>
        <div class="flex-1 text-gray-700">{{ loadWeightFound ? 'Found' : 'Not Found' }}</div>
      </div>
      <div
        class="pt-1 pb-1 flex border-b border-gray-400"
        (mouseenter)="highlightLocationType = DATE_LOCATION_TYPE"
        (mouseleave)="highlightLocationType = ''"
      >
        <div class="flex-1 text-gray-700">Completion Time:</div>
        <div class="flex-1 text-gray-700">{{ orderBOLOCR.completedAtLocalTime | standardDate }}</div>
        <div class="flex-1 text-gray-700">{{ dateFound ? 'Found' : 'Not Found' }}</div>
      </div>
    </div>
    <div class="w-3/4">
      <!-- need to set this div to be the same size as the image, so that the highlights will position correctly -->
      <div class="relative" [style.max-width.px]="bolImg?.naturalWidth" [style.max-height.px]="bolImg?.naturalHeight">
        <img #bolImg [src]="orderBOLOCR.bolOriginalImageUrl" />
        <ng-container
          *ngFor="
            let locationType of orderBOLOCR.ocrDataLocations;
            trackBy: orderBOLOCR.ocrDataLocations | trackByKey2: 'locationValueTypeCode'
          "
        >
          <div
            *ngFor="let location of locationType.locationValue; trackBy: locationType.locationValue | trackByKey2: null"
            class="absolute bg-green-lime opacity-50"
            [style.top.%]="((location[1] - 3) * 100) / bolImg.naturalHeight"
            [style.left.%]="((location[0] - 3) * 100) / bolImg.naturalWidth"
            [style.height.%]="((location[3] - location[1] + 6) * 100) / bolImg.naturalHeight"
            [style.width.%]="((location[2] - location[0] + 6) * 100) / bolImg.naturalHeight"
          ></div>
          <ng-container *ngIf="highlightLocationType === locationType.locationValueTypeCode">
            <div
              *ngFor="
                let location of locationType.locationValue;
                trackBy: locationType.locationValue | trackByKey2: null
              "
              class="absolute border-4 border-green-lime"
              [style.top.%]="((location[1] - 6) * 100) / bolImg.naturalHeight"
              [style.left.%]="((location[0] - 6) * 100) / bolImg.naturalWidth"
              [style.height.%]="((location[3] - location[1] + 12) * 100) / bolImg.naturalHeight"
              [style.width.%]="((location[2] - location[0] + 12) * 100) / bolImg.naturalHeight"
            ></div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>
